/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetPaginationTransactionsResponse,
  UtxTransactionsV2ListTransactionsParams,
  GetPaginationIncomingTransactionsResponse,
  UtxTransactionsV2ListIncomingTransactionsParams,
  GetPaginationOutgoingTransactionsResponse,
  UtxTransactionsV2ListOutgoingTransactionsParams,
  GetPaginationExchangeTransactionsResponse,
  UtxTransactionsV2ListExchangesParams,
  GetPaginationTransferTransactionsResponse,
  UtxTransactionsV2ListTransfersParams,
  GetTransactionDetailResponse,
  TransactionModelResponse,
  UtxTransactionDownloadReportTransactionParams
} from './schema'



export const utxTransactionsV2ListTransactions = (
    params?: UtxTransactionsV2ListTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPaginationTransactionsResponse>> => {
    return axios.get(
      `/transactions-v2`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransactionsV2ListTransactionsQueryKey = (params?: UtxTransactionsV2ListTransactionsParams,) => [`/transactions-v2`, ...(params ? [params]: [])];

    
export type UtxTransactionsV2ListTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransactionsV2ListTransactions>>>
export type UtxTransactionsV2ListTransactionsQueryError = AxiosError<unknown>

export const useUtxTransactionsV2ListTransactions = <TData = Awaited<ReturnType<typeof utxTransactionsV2ListTransactions>>, TError = AxiosError<unknown>>(
 params?: UtxTransactionsV2ListTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransactionsV2ListTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransactionsV2ListTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransactionsV2ListTransactions>>> = ({ signal }) => utxTransactionsV2ListTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransactionsV2ListTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransactionsV2ListIncomingTransactions = (
    params?: UtxTransactionsV2ListIncomingTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPaginationIncomingTransactionsResponse>> => {
    return axios.get(
      `/transactions-v2/incoming`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransactionsV2ListIncomingTransactionsQueryKey = (params?: UtxTransactionsV2ListIncomingTransactionsParams,) => [`/transactions-v2/incoming`, ...(params ? [params]: [])];

    
export type UtxTransactionsV2ListIncomingTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransactionsV2ListIncomingTransactions>>>
export type UtxTransactionsV2ListIncomingTransactionsQueryError = AxiosError<unknown>

export const useUtxTransactionsV2ListIncomingTransactions = <TData = Awaited<ReturnType<typeof utxTransactionsV2ListIncomingTransactions>>, TError = AxiosError<unknown>>(
 params?: UtxTransactionsV2ListIncomingTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransactionsV2ListIncomingTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransactionsV2ListIncomingTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransactionsV2ListIncomingTransactions>>> = ({ signal }) => utxTransactionsV2ListIncomingTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransactionsV2ListIncomingTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransactionsV2ListOutgoingTransactions = (
    params?: UtxTransactionsV2ListOutgoingTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPaginationOutgoingTransactionsResponse>> => {
    return axios.get(
      `/transactions-v2/outgoing`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransactionsV2ListOutgoingTransactionsQueryKey = (params?: UtxTransactionsV2ListOutgoingTransactionsParams,) => [`/transactions-v2/outgoing`, ...(params ? [params]: [])];

    
export type UtxTransactionsV2ListOutgoingTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransactionsV2ListOutgoingTransactions>>>
export type UtxTransactionsV2ListOutgoingTransactionsQueryError = AxiosError<unknown>

export const useUtxTransactionsV2ListOutgoingTransactions = <TData = Awaited<ReturnType<typeof utxTransactionsV2ListOutgoingTransactions>>, TError = AxiosError<unknown>>(
 params?: UtxTransactionsV2ListOutgoingTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransactionsV2ListOutgoingTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransactionsV2ListOutgoingTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransactionsV2ListOutgoingTransactions>>> = ({ signal }) => utxTransactionsV2ListOutgoingTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransactionsV2ListOutgoingTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransactionsV2ListExchanges = (
    params?: UtxTransactionsV2ListExchangesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPaginationExchangeTransactionsResponse>> => {
    return axios.get(
      `/transactions-v2/exchange`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransactionsV2ListExchangesQueryKey = (params?: UtxTransactionsV2ListExchangesParams,) => [`/transactions-v2/exchange`, ...(params ? [params]: [])];

    
export type UtxTransactionsV2ListExchangesQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransactionsV2ListExchanges>>>
export type UtxTransactionsV2ListExchangesQueryError = AxiosError<unknown>

export const useUtxTransactionsV2ListExchanges = <TData = Awaited<ReturnType<typeof utxTransactionsV2ListExchanges>>, TError = AxiosError<unknown>>(
 params?: UtxTransactionsV2ListExchangesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransactionsV2ListExchanges>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransactionsV2ListExchangesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransactionsV2ListExchanges>>> = ({ signal }) => utxTransactionsV2ListExchanges(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransactionsV2ListExchanges>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransactionsV2ListTransfers = (
    params?: UtxTransactionsV2ListTransfersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPaginationTransferTransactionsResponse>> => {
    return axios.get(
      `/transactions-v2/transfers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransactionsV2ListTransfersQueryKey = (params?: UtxTransactionsV2ListTransfersParams,) => [`/transactions-v2/transfers`, ...(params ? [params]: [])];

    
export type UtxTransactionsV2ListTransfersQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransactionsV2ListTransfers>>>
export type UtxTransactionsV2ListTransfersQueryError = AxiosError<unknown>

export const useUtxTransactionsV2ListTransfers = <TData = Awaited<ReturnType<typeof utxTransactionsV2ListTransfers>>, TError = AxiosError<unknown>>(
 params?: UtxTransactionsV2ListTransfersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransactionsV2ListTransfers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransactionsV2ListTransfersQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransactionsV2ListTransfers>>> = ({ signal }) => utxTransactionsV2ListTransfers(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransactionsV2ListTransfers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransactionsV2GetTransaction = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetTransactionDetailResponse>> => {
    return axios.get(
      `/transactions-v2/${id}`,options
    );
  }


export const getUtxTransactionsV2GetTransactionQueryKey = (id: string,) => [`/transactions-v2/${id}`];

    
export type UtxTransactionsV2GetTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransactionsV2GetTransaction>>>
export type UtxTransactionsV2GetTransactionQueryError = AxiosError<void>

export const useUtxTransactionsV2GetTransaction = <TData = Awaited<ReturnType<typeof utxTransactionsV2GetTransaction>>, TError = AxiosError<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransactionsV2GetTransaction>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransactionsV2GetTransactionQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransactionsV2GetTransaction>>> = ({ signal }) => utxTransactionsV2GetTransaction(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransactionsV2GetTransaction>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Download transaction csv report
 */
export const utxTransactionDownloadReportTransaction = (
    params: UtxTransactionDownloadReportTransactionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TransactionModelResponse>> => {
    return axios.get(
      `/transaction/download-report`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransactionDownloadReportTransactionQueryKey = (params: UtxTransactionDownloadReportTransactionParams,) => [`/transaction/download-report`, ...(params ? [params]: [])];

    
export type UtxTransactionDownloadReportTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransactionDownloadReportTransaction>>>
export type UtxTransactionDownloadReportTransactionQueryError = AxiosError<unknown>

export const useUtxTransactionDownloadReportTransaction = <TData = Awaited<ReturnType<typeof utxTransactionDownloadReportTransaction>>, TError = AxiosError<unknown>>(
 params: UtxTransactionDownloadReportTransactionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransactionDownloadReportTransaction>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransactionDownloadReportTransactionQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransactionDownloadReportTransaction>>> = ({ signal }) => utxTransactionDownloadReportTransaction(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransactionDownloadReportTransaction>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

